import config from 'shared/config';
import connector from 'api/http';

import {
  ApiData,
  RecentInsurerOptions,
  RefDataType,
} from 'scenes/common/types';
import {
  unmarshalInsurers,
  unmarshalRefData,
} from 'scenes/common/api/referenceData';
import { makeApiError } from 'scenes/common/helpers/apiData';

import { unmarshalCoverLevels } from './marshaller';
import { CoverLevel } from './types';

const api = (baseUrl: string = config.baseUrls.BFF_BASE_URL) => {
  const server = connector(baseUrl);

  return {
    getInsurers: (): Promise<ApiData<RecentInsurerOptions>> =>
      server
        .get('/referencedata/motor/CURRTINSUR')
        .then(unmarshalInsurers)
        .catch((err) => makeApiError(err.message)),

    getCoverLevels: (): Promise<ApiData<CoverLevel[]>> =>
      server
        .get('/referencedata/motor/CURRTINSURCOVLVL')
        .then(unmarshalCoverLevels)
        .catch((err) => makeApiError(err.message)),

    getBusinessTypes: (): Promise<ApiData<RefDataType[]>> =>
      server
        .get('/referencedata/motor/BUSUSE')
        .then(unmarshalRefData)
        .catch((err) => makeApiError(err.message)),

    getFinancialInstitutions: (): Promise<ApiData<RefDataType[]>> =>
      server
        .get('/referencedata/motor/FININST')
        .then(unmarshalRefData)
        .catch((err) => makeApiError(err.message)),
  };
};

export default api;
